<template>
  <div>
    <v-row>
      <v-col cols="6" sm="3" md="2">
        <FormattedNumberField
          label="January"
          :value="directPlacementGoalValue[0].goal"
          :hide-details="true"
          prepend-inner-icon="attach_money"
          @valueChange="(newValue) => this.directPlacementGoalValue[0].goal = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="6" sm="3" md="2">
        <FormattedNumberField
          label="February"
          :value="directPlacementGoalValue[1].goal"
          :hide-details="true"
          prepend-inner-icon="attach_money"
          @valueChange="(newValue) => this.directPlacementGoalValue[1].goal = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="6" sm="3" md="2">
        <FormattedNumberField
          label="March"
          :value="directPlacementGoalValue[2].goal"
          :hide-details="true"
          prepend-inner-icon="attach_money"
          @valueChange="(newValue) => this.directPlacementGoalValue[2].goal = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="6" sm="3" md="2">
        <FormattedNumberField
          label="April"
          :value="directPlacementGoalValue[3].goal"
          :hide-details="true"
          prepend-inner-icon="attach_money"
          @valueChange="(newValue) => this.directPlacementGoalValue[3].goal = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="6" sm="3" md="2">
        <FormattedNumberField
          label="May"
          :value="directPlacementGoalValue[4].goal"
          :hide-details="true"
          prepend-inner-icon="attach_money"
          @valueChange="(newValue) => this.directPlacementGoalValue[4].goal = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="6" sm="3" md="2">
        <FormattedNumberField
          label="June"
          :value="directPlacementGoalValue[5].goal"
          :hide-details="true"
          prepend-inner-icon="attach_money"
          @valueChange="(newValue) => this.directPlacementGoalValue[5].goal = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="6" sm="3" md="2">
        <FormattedNumberField
          label="July"
          :value="directPlacementGoalValue[6].goal"
          :hide-details="true"
          prepend-inner-icon="attach_money"
          @valueChange="(newValue) => this.directPlacementGoalValue[6].goal = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="6" sm="3" md="2">
        <FormattedNumberField
          label="August"
          :value="directPlacementGoalValue[7].goal"
          :hide-details="true"
          prepend-inner-icon="attach_money"
          @valueChange="(newValue) => this.directPlacementGoalValue[7].goal = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="6" sm="3" md="2">
        <FormattedNumberField
          label="September"
          :value="directPlacementGoalValue[8].goal"
          :hide-details="true"
          prepend-inner-icon="attach_money"
          @valueChange="(newValue) => this.directPlacementGoalValue[8].goal = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="6" sm="3" md="2">
        <FormattedNumberField
          label="October"
          :value="directPlacementGoalValue[9].goal"
          :hide-details="true"
          prepend-inner-icon="attach_money"
          @valueChange="(newValue) => this.directPlacementGoalValue[9].goal = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="6" sm="3" md="2">
        <FormattedNumberField
          label="November"
          :value="directPlacementGoalValue[10].goal"
          :hide-details="true"
          prepend-inner-icon="attach_money"
          @valueChange="(newValue) => this.directPlacementGoalValue[10].goal = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="6" sm="3" md="2">
        <FormattedNumberField
          label="December"
          :value="directPlacementGoalValue[11].goal"
          :hide-details="true"
          prepend-inner-icon="attach_money"
          @valueChange="(newValue) => this.directPlacementGoalValue[11].goal = newValue"
        ></FormattedNumberField>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { FormattedNumberField } from '@/components/shared/textFields'

export default {
  components: {
    FormattedNumberField
  },
  props: [
    'directPlacementGoals'
  ],
  computed: {
    directPlacementGoalValue: {
      get () {
        return this.directPlacementGoals
      },
      set (newValue) {
        this.$emit('directPlacementGoalChange', newValue)
      }
    }
  }
}
</script>
